import { Desktop, MobileOrTablet } from '../media-queries';
import WhyKeyes2SafetyDesktop from './desktop';
import WhyKeyes2SafetyMobile from './mobile';

const WhyKeyes2SafetyPage= () => {
    return <>
        <Desktop>
            <WhyKeyes2SafetyDesktop />
        </Desktop>
        <MobileOrTablet>
            <WhyKeyes2SafetyMobile/>
        </MobileOrTablet>
    </>
}

export default WhyKeyes2SafetyPage